import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { EnvironmentLoaderService } from './BackEndURL/environment-loader.service';

interface ApiInfo {
  name: string;
  version: string;
  hasSubApi: boolean;
}

const API_INFOS = {
  enterpriseApi: {
    name: 'enterpriseApi',
    // version: '0.1',
    hasSubApi: true,
  } as ApiInfo,
  // we can add another app in the future
};

export const API_NAMES = {
  administration: 'administration',
  deployment: 'deployment',
  adminStock: 'administration/stocks',
  adminAssets: 'administration/assets',
  identity: 'identity',
  modules: 'modules',
  stocks: 'modules/stocks',
  assets: 'modules/assets',
  common: 'modules/common',
  settings: 'modules/settings',
};

const API_NAME_VALUES = Object.values(API_NAMES);

@Injectable({ providedIn: 'root' })
export class ApiHelper {
  constructor(private env: EnvironmentLoaderService) { }
  static APIUrl: string = '';

  getBaseWithoutApi() {
    let apiInfo = API_INFOS.enterpriseApi;

    const endPointName = apiInfo.name;
    let APIKey = EnvironmentLoaderService.envConfig;// <BackEndURLSettings>JSON.parse(localStorage.getItem('localKey'));

    if (APIKey) {
      return APIKey.enterpriseApiLocal;
    }
    //else */
    //return `${environment.api.urls[endPointName]}`;
  }

  getBase(name: string) {
    this._validateName(name);
    const apiInfo = API_INFOS.enterpriseApi;
    const { version, hasSubApi } = apiInfo;
    const subPath = hasSubApi ? `/${name}` : '';
    //return `${this.getBaseWithoutApi()}/api/v${version}${subPath}`; // if we use versioning
    return `${this.getBaseWithoutApi()}/api${subPath}`;
  }

  private _validateName(name: string) {
    if (API_NAME_VALUES.indexOf(name) < 0) {
      throw new Error(`api name '${name}' is not valid.`);
    }
  }
}

export abstract class ApiServiceBase {
  private _injector: Injector;
  private _httpClient: HttpClient;

  protected _base: string;
  protected _apiHelper: ApiHelper;
  constructor(apiHelperOrInjector: ApiHelper | Injector) {   // For back-compat
    if (apiHelperOrInjector instanceof ApiHelper) {
      this._apiHelper = apiHelperOrInjector;
    }
    else {
      this._injector = apiHelperOrInjector;
      this._apiHelper = this._injector.get(ApiHelper);
      this._httpClient = this._injector.get(HttpClient);
    }
  }

  get injector() {
    return this._injector;
  }

  get apiHelper() {
    return this._apiHelper;
  }

  get client(): HttpClient {
    this._validateInjector();
    return this._httpClient;
  }

  url(path: string, base?: string) {
    return `${base || this._base}${path}`;
  }

  getBase(name: string) {
    return this._apiHelper.getBase(name);
  }

  setBase(name: string) {
    this._base = this.getBase(name);
  }

  private _validateInjector() {
    if (!this._injector) {
      throw new Error('No injector was provided in the ctor.');
    }
    return true;
  }
}
